import { render } from "./HelpArticle.vue?vue&type=template&id=08c14748"
import script from "./HelpArticle.vue?vue&type=script&lang=js"
export * from "./HelpArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__